module.exports = __webpack_public_path__ + "img/399.34012060.png";